import { render, staticRenderFns } from "./ModuleFrame.vue?vue&type=template&id=75d68a2a&"
import script from "./ModuleFrame.vue?vue&type=script&lang=js&"
export * from "./ModuleFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports